import { fork } from "redux-saga/effects";

import wssync from "./wssync";

export default function* oktellWatcher(config) {
  yield fork(wssync, config);
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/oktell/saga.js